// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"7b2c9a27","223":"696576e4","390":"84125961","453":"faaab328","580":"e41c4611"}[chunkId] + ".chunk.js";
};